import Fluide from './Fluide'
import Offline from './Offline'
import Api from '../core/Api'
import localforage from 'localforage'
import User from "./User";
import Detenteur from "./Detenteur";
import installation from "@/components/installation/Installation.vue";

class Installation {
    static serialize(data) {

        if(_.includes(data.id, 'N-')){
            data.temporaire_id = data.id;
        }

        let install = Object.assign({}, data);

        install.puissanceElectrique = install.puissance_electrique;
        delete install.puissance_electrique;
        install.puissanceCalorifique = install.puissance_calorifique;
        delete install.puissance_calorifique;
        install.puissanceFrigorifique = install.puissance_frigorifique;
        delete install.puissance_frigorifique;
        install.frequenceControle = install.frequence_controle;
        delete install.frequence_controle;
        install.forceFrequence = install.force_frequence;
        delete install.force_frequence;

        if (install.hasOwnProperty('fluide') && install.fluide !== null && install.fluide.hasOwnProperty('id')) {
            install.fluide = install.fluide.id;
            delete install.created_at;
            delete install.updated_at
        } else {
            install.detecteur = false;
            delete install.fluide;
            delete install.charge;
            delete install.tonnage;
            delete install.frequenceControle
        }

        return install
    }

    static addInstallationOffline(data) {
        return new Promise((resolve, reject) => {
            let installation = data.data.installation;
            let idDet = data.idDet;

            if (!_.includes(idDet, 'N-')) {
                idDet = parseInt(idDet)
            }

            let tempId = 'N-' + +new Date();

            installation.id = tempId;
            installation.actif = true;
            installation.detenteur = idDet;

            this.getList().then(data => {
                data.push(installation);

                localforage
                    .setItem('listInstallations', JSON.stringify(data))
                    .then(() => {

                        return Offline.saveAction({
                            action: 'add',
                            type: 'Installation',
                            id: tempId
                        });

                    }).then(() => {
                        resolve(true)
                }).catch(err => reject(err))
            })
        })
    }

    static getInstallOnline(id) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .get('/installation/' + id)
                        .then(result => {
                            if(!_.isEmpty(result.data) && (result.data[0] !== "undefined")){
                                resolve(result.data[0]);
                            }else{
                                reject(id);
                            }
                        })
                })
        })
    }
    static getAlertes(installation) {
        return new Promise((resolve, reject) => {
            let alertes = {};
            let alertDesp = null;
            let alertMaintenance = null;
            let alertAttestation = null;
            let alertPeriodique = null;


            if(installation.charge !== null && installation.frequence_controle !== null) {
                alertPeriodique = this.getAlert(installation.last_control, installation.frequence_controle);
            }

            if (alertPeriodique !== null) {
                alertes.periodique = alertPeriodique;
            }

            if(installation.last_information_attestation === null && installation.last_information_desp === null && installation.last_information_maintenance === null){
                return resolve(alertes);
            }

            if(installation.last_information_desp !== null){
                if(installation.last_information_desp.display === true) {
                    if(installation.last_information_desp.is_checked === true) {
                        alertDesp = this.getAlert(installation.last_information_desp.last_date, installation.last_information_desp.alarm);
                    }
                }
            }

            if(installation.last_information_maintenance !== null){
                if(installation.last_information_maintenance.display === true) {
                    if(installation.last_information_maintenance.is_checked === true) {
                        alertMaintenance = this.getAlert(installation.last_information_maintenance.last_date, installation.last_information_maintenance.alarm);
                    }
                }
            }

            if(installation.last_information_attestation !== null){
                if(installation.last_information_attestation.display === true) {
                    if(installation.last_information_attestation.is_checked === true) {
                        alertAttestation = this.getAlert(installation.last_information_attestation.last_date, installation.last_information_attestation.alarm);
                    }
                }
            }


            if (alertDesp !== null) {
                alertes.desp = alertDesp;
            }

            if (alertMaintenance !== null) {
                alertes.maintenance = alertMaintenance;
            }

            if (alertAttestation !== null) {
                alertes.attestation = alertAttestation;
            }

            return resolve(alertes);
        })
    }

    static addInstallationOnline(data) {

        return new Promise((resolve, reject) => {

            Api
                .init()
                .then(api => {
                    api
                        .post('/installation', data)
                        .then(res => {
                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(res.data)
                            } else {
                                let errs = {
                                    apiMsg: res.data.errors,
                                    payload: data,
                                    full: res
                                };
                                reject(errs)
                            }
                        }).catch(err => reject(err))
                }).catch(err => reject(err))
        })

    }

    static updateOnline(data) {
        return new Promise((resolve, reject) => {
            let idInstall = data.id;

            if (!idInstall) {
                resolve(true);
            }

            Api
                .init()
                .then(api => {
                    api
                        .put('/installation/' + idInstall, data)
                        .then(res => {
                            if (!res.data.hasOwnProperty('errors')) {

                                Offline
                                    .deleteAction(idInstall, 'Installation')
                                    .then(() => resolve(true))
                                    .catch(err => reject(err))

                            } else {
                                reject(res.data.errors)
                            }


                        })
                        .catch(err => {
                            if (err.response.status === 403 || err.response.status === 404) {
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))
        })
    }

    static async applyRetrofit(idInstall, idFi) {
        const ops = JSON.parse(await localforage.getItem('listOperations')).filter(item => {
            if (item.id_fibsdd === idFi && _.includes(item.type, 'Ajout')) {
                return item;
            }
        });

        if (ops.length !== 0) {

            let newCharge = ops.reduce((somme, op) => {
                return round(somme + op.quantite, 3)
            }, 0);

            const fluide = _.find(JSON.parse(await localforage.getItem('listFluides')).noFiltre, ['id', ops[0].id_fluide]);
            let installations = JSON.parse(await localforage.getItem('listInstallations'));
            const indexInstall = _.findIndex(installations, ['id', idInstall]);
            const newTonnage = Fluide.calcTonnage(fluide, newCharge);
            const detec = installations[indexInstall].detecteur;
            const newFreq = Installation.calcFrequence(detec, newTonnage, newCharge, fluide);

            installations[indexInstall].fluide = fluide;
            installations[indexInstall].charge = newCharge;
            installations[indexInstall].tonnage = newTonnage;
            installations[indexInstall].frequence_controle = newFreq;

            await localforage.setItem('listInstallations', JSON.stringify(installations));
            await Offline.saveAction({
                action: 'update',
                type: 'Installation',
                id: idInstall
            });

            return true
        } else {
            return false
        }
    }

    static async applyDemantelement(idInstall) {
        let installations = JSON.parse(await localforage.getItem('listInstallations'));
        const indexInstall = _.findIndex(installations, ['id', idInstall]);
        installations[indexInstall].actif = false;

        await localforage.setItem('listInstallations', JSON.stringify(installations));
        await Offline.saveAction({
            action: 'update',
            type: 'Installation',
            id: idInstall
        });

        return true

    }

    static calcFrequence(detec, tonnage, charge, fluide) {

        let freq = 0;

        if (fluide.type === 'HCFC') {
            if (charge > 3 && charge < 30) {
                freq = 12;
            } else if (charge >= 30 && charge < 300) {
                freq = 6;
            } else if (charge >= 300) {
                freq = 3;
            }
        } else if (fluide.type !== 'HCFC') {
            if (tonnage > 5 && tonnage < 50) {
                freq = 12;
            } else if (tonnage >= 50 && tonnage < 500) {
                freq = 6;
            } else if (tonnage >= 500) {
                freq = 3;
            }
        }

        if (detec === true) {
            freq = freq * 2
        }

        return freq

    }

    static getInstallation(id) {

        return new Promise((resolve, reject) => {
            if (!_.includes(id, 'N-')) {
                id = parseInt(id)
            }

            localforage
                .getItem('listInstallations')
                .then(res => {
                    let installations = JSON.parse(res);
                    let install = installations.find(item => item.id === id);

                    if(install !== undefined){
                        resolve(install);
                    }else{
                        resolve(this.getInstallOnline(id));
                        reject(id);
                    }
                })
                .catch(err => reject(err))
        })
    }

    static getInstallationsForDet(idDet) {

        return new Promise((resolve, reject) => {
            if (!_.includes(idDet, 'N-')) {
                idDet = parseInt(idDet)
            }

            localforage
                .getItem('listInstallations')
                .then(res => {
                    let installations = JSON.parse(res);
                    let filtred = _.filter(installations, {
                        'detenteur': idDet
                    });
                    resolve(filtred)
                })
                .catch(err => reject(err))
        })
    }

    static askAddInstall(idDet) {

        User
        .getUserData(data => {

            let html = '';
            html += '<div class="flex flex-col gap-3 items-center">';
            html += '<a class="bg-primary text-white px-4 py-2 rounded-lg text-sm font-semibold shadow hover:opacity-90 transition w-full text-center addbouteille" onclick="swal.closeModal()" href="fi360://scan?success=tryGoToInstall&idDet=' + idDet + '">SCAN OTAG</a>';
            html += '<a class="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold shadow hover:bg-gray-300 transition w-full text-center addbouteille" onclick="swal.closeModal()" href="#/detenteur/' + idDet + '/installations/new">AJOUTER SANS PUCE</a>';
            html += '</div>';

            swal({
                title: 'Ajout installation',
                showConfirmButton: false,
                html
            })
        })


    }

    static findOnInstall(value, type = "i_tag") {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listInstallations')
                .then(res => {
                    res = JSON.parse(res);

                    let install = _.find(res, [type, value]);

                    //console.log('install findOnInstall', install);

                    if(typeof install === 'undefined'){
                        resolve(false);
                    }else{
                        resolve(install);
                    }
                })
        })
    }

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listInstallations')
                .then(res => resolve(JSON.parse(res)))
                .catch(err => reject(err))
        })
    }

    static getAlert(date, alarm = 0) {

        //console.log('alarm', alarm)

        if(alarm === 0 || date === null) {
            return null;
        }

        if(!(date instanceof Date)){
            date = new Date(date);
        }

        const now = new Date();
        const warningMonth = alarm - 1;
        const alertDate = new Date(date);
        const warningDate = new Date(date);
        alertDate.setMonth(alertDate.getMonth() + alarm);
        warningDate.setMonth(warningDate.getMonth() + warningMonth);

        if (now >= alertDate) {
            return "alert";
        }

        if (now >= warningDate) {
            return "warning";
        }



        return null;

    }

    static updateInstallation(install) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(lstInstalls => {
                    let id = install.id;
                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }
                    let index = _.findIndex(lstInstalls, ['id', id]);
                    lstInstalls[index] = install;
                    localforage
                        .setItem('listInstallations', JSON.stringify(lstInstalls))
                        .then(() => {

                            Offline
                                .saveAction({
                                    action: 'update',
                                    type: 'Installation',
                                    id: id
                                })
                                .then(() => resolve(true))
                                .catch(err => reject(err))
                        })
                        .catch(err => reject(err))
                })
        });
    }
}

export default Installation



// WEBPACK FOOTER //
// ./src/js/models/Installation.js